import React, { useEffect, useState } from "react";
import { Table } from "antd";

const Datatable = ({ columns, dataSource, Search, pagination }) => {
  const [searchText, setSearchText] = useState("");
  const [showSearch, setShowSearch] = useState(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  const handleSearch = (value) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  useEffect(() => {
    setShowSearch(Search);
  }, [Search]);

  return (
    <div className="custom-table antd-custom-table">
      {!showSearch ? (
        <Table
          className="table datanew dataTable no-footer"
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
      pagination={pagination !== undefined ? pagination : false}
        />
      ) : (
        <>
          <div className="table-search">
            <div className="input-icon mb-3">
              <span className="input-icon-addon">
                <i className="isax isax-search-normal-14" />
              </span>
              <input
                type="search"
                className="form-control form-control-md mb-3 w-auto float-end"
                value={searchText}
                placeholder="Search"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>
          <Table
            className="table datanew dataTable no-footer"
            columns={columns}
            rowHoverable={false}
            dataSource={filteredDataSource}
      pagination={pagination !== undefined ? pagination : false}
          />
        </>
      )}
    </div>
  );
};

export default Datatable;
